import React, {ReactElement, useCallback, useEffect, useState} from 'react';
import {scriptLoader} from "../../handlers/scriptLoader";
import {Outlet, useNavigate} from "react-router";
import {useSession} from "../SessionContext";
import * as http from '../../handlers/http';
import {initSessionRefresh, setNonce} from "../auth";
import AdminPage from "../../components/pages/admin/AdminPage";
import {PAGES_PATHS} from "../../Entrypoint";
import {ErrorParam} from "../../components/pages/ErrorPage";
import {ErrorCode} from "../../types/Error";

const GoogleLoginGate = (): ReactElement => {
	const {setSession} = useSession();
	const navigate = useNavigate();
	const [authorized, setAuthorized] = useState<boolean>(false);

	useEffect(() => {
		setNonce(null);
		setSession(null);

		http.post<void>('/web/auth/revoke')
				.then(() => prepareGoogleLogin())
				.catch(() => {
					navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.AUTHENTICATION_ERROR}`, {replace: true});
				});
	}, []);

	const prepareGoogleLogin = useCallback((): void => {
		http.get<{ result: string }>("/web/auth/google-id")
				.then(res => {
					scriptLoader('google-sign-in-api', 'https://accounts.google.com/gsi/client', () => googleCallback(res.result));
				})
				.catch((err) => {
					console.error(err)
					navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.AUTHENTICATION_ERROR}`, {replace: true});
				})
	}, []);

	const googleCallback = useCallback((authID: string) => {
		const google = window.google;
		const googleButton = document.getElementById('google-sign-in-button');

		if (google && googleButton) {
			google.accounts.id.initialize({
				client_id: authID,
				callback: handleGoogleResponse,
			});
			google.accounts.id.renderButton(googleButton, {
				theme: 'filled_blue',
				size: 'medium',
				text: 'signin_with',
				shape: 'rectangular',
			});
		}
	}, []);

	function handleGoogleResponse(res: any) {
		const token = res.credential;
		http.post<{ result: string }>(`/web/auth/google`, {token})
				.then(res => {
					console.log("%c ZEEROmed Upload web UI", "font-size: 1.3rem;color: #20a8d8");
					initSessionRefresh();
					setNonce(res.result)
					setAuthorized(true);
				})
				.catch((err) => {
					console.error(err)
					navigate(`/${PAGES_PATHS.ERROR}?${ErrorParam.KEY}=${ErrorCode.AUTHENTICATION_ERROR}`, {replace: true});
				});
	}

	return (
			<React.Fragment>
				{authorized ? (
						<React.Fragment>
							<AdminPage><Outlet/></AdminPage>
						</React.Fragment>
				) : (
						<div id="login-page">
							<div id="login-container">
								<div id="logo-container">
									<img id="login-logo" alt=""/>
								</div>
								<div id="google-sign-in-button"></div>
							</div>
						</div>
				)}
			</React.Fragment>
	)
};

export default GoogleLoginGate;
